<style lang="less" scoped>

</style>

<template lang="pug">
  div .
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      query: state => state.route.query,
    }),
  },
  mounted() {
    window.opener.resultSubmit(this.query.allat_result_cd, this.query.allat_result_msg, this.query.allat_enc_data);
    window.close();
  },
};
</script>
